function isAnalyticsEnabled() {
  if (navigator.doNotTrack === null) return true;

  return !Number(navigator.doNotTrack);
}

export default isAnalyticsEnabled;
